__webpack_require__.p = "/guessthestock/";